<template>
    <div>
        <div class="row">
            <div class="col">
                <span class="lbl-title"><i v-if="icon" class="fa" :class="icon" aria-hidden="true"></i> {{ title }} </span>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'label-title',
    props: {
      title: { type: String },
      icon: { type: String },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/label-title.vue